import './Notes.css';

const Notes = ()=>{


return (
    <div style={{backgroundColor:"#0f172a", alignText:"center", minHeight:"40vh", paddingBottom:"2rem"}}>
         <h1 style={{textAlign:"center", fontSize:"2rem", padding:"0 1rem", color:"#e0e0e0"}}>
                Written things
        </h1>
        <p style={{maxWidth:"800px", margin:"auto", padding:"0 1rem", color:"#e0e0e0"}}>
            {/* This is a collection of my notes (many from class), short expositions on various topics, and solutions to exercises in books I have worked through. If they are not currently linked that probably means I am just polishing them at the moment. */}
            </p>
        {/*<ul>
            <li>Math 213A (unfinished)</li>
            <li>Math 222 (coming soon)</li>


        </ul> */}
        <section className="three-col__wrapper">
  <div className="three-col">
    <div className="three-col__title">
    {/* <h4>Class Notes</h4>
    <ul className="notes-list">
      {/* <li>Math 222</li>
      <li>Math 129</li> *
      <li className="notes-item notes-item--muted">
        <span>Coming soon</span>
      </li>
    </ul> */}
    </div>
    <div className="three-col__title">
        <h4>Expositions</h4>
    <ul className="notes-list">
      <li className="notes-item notes-item--muted">
        <span>Towards Stacks (work in progress)</span>
      </li>
      <li className="notes-item">
        <a href="/Math_259A_final_project%20(1).pdf" className="notes-link">
          Constructing Exotic 4-Manifolds via Lefschetz Fibrations (my Math 259A final project)
        </a>
      </li>
    </ul>
    </div><div className="three-col__title"> 
        {/* <h4>Solutions to Exercises</h4> */}
     <ul className="notes-list">
      {/* <li>Stephen Abbott's <em>Understanding Analysis</em></li> */}
      {/* <li>Item 1B</li>
      <li>Item 1C</li> */}
    </ul> 
    </div>
  </div>
</section>
    </div>

)

}

export default Notes